module.exports = __webpack_public_path__ + "static/fa6-b79db7399c132b24650dd53ff033bf88.jpg";